export default {
  id: "",
  complete: false,
  player: "",
  players: {},
  hasOpponent: false,
  isAgainstComputer: false,
  message: "",
  hands: {
    rock: "scissors",
    paper: "rock",
    scissors: "paper"
  },
  socket: false
};